module.exports = __webpack_public_path__ + "130aacdb4f95454c08f9e75610f31137.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-flag-kit/assets/YE.svg
// module id = o3tX
// module chunks = 0